import './footer.css'

export default function Footer(){
    return (
        <footer className="footer">
            <p>Salão Lima &copy; 2023</p>
        </footer>
    )
}